import React, {useEffect} from "react";

function Footer() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section class="footer-section">
                <div class="container">
                    <div class="row position-relative">
                        <div class="col-xl-5 col-lg-4 col-md-5 col-sm-6 text-sm-left text-center">
                            <div class="footer-logo-content">
                                <figure class="footer-logo mb-2">
                                    <img class="img-fluid w-75" src="/assets/final-logo-sd-footer.png" alt="" />
                                </figure>
                                <p class="text-size-16 mb-lg-4 mb-md-3 mb-3">
                                    CALL CENTER SERVICES FOR THE RESTAURANT INDUSTRY
                                </p>
                                <ul class="footer-logo-content-listing p-0 m-0">
                                    <li class="list-unstyled d-inline-block">
                                        <a class="d-inline-block" href="#">
                                            <i class="fab fa-facebook-square"></i>
                                        </a>
                                    </li>
                                    <li class="list-unstyled d-inline-block">
                                        <a class="d-inline-block" href="#">
                                            <i class="fab fa-twitter-square"></i>
                                        </a>
                                    </li>
                                    <li class="list-unstyled d-inline-block">
                                        <a class="d-inline-block" href="#">
                                            <i class="fab fa-linkedin"></i>
                                        </a>
                                    </li>
                                    <li class="list-unstyled d-inline-block">
                                        <a class="d-inline-block" href="#">
                                            <i class="fab fa-pinterest-square"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 d-lg-block d-md-none d-sm-none d-none"></div>
                        <div class="col-lg-4 col-md-4 col-sm-6 text-sm-left text-center d-sm-block d-none">
                            <div class="footer-info-content">
                                <h5 class="font-weight-normal">Get in Touch</h5>
                                <ul class="list-unstyled mb-0">
                                    <li>
                                        <span class="font-weight-bold">Email: </span>
                                        <a class="text-decoration-none font-weight-normal"
                                           href="mailto:info@remoterestaurantsupport.com">
                                            info@remoterestaurantsupport.com
                                        </a>
                                    </li>
                                    <li>
                                        <span class="font-weight-bold">Phone: </span>
                                        <a class="text-decoration-none font-weight-normal"
                                           href="tel:+14012035794">+1 401-203-5794</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <figure class="footer-secrion-shape-img-1 mb-0 position-absolute">
                            <img
                                class="img-fluid" src="/assets/images/footer-section-shape-img-1.png" alt=""
                            />
                        </figure>
                    </div>
                </div>
            </section>
            <div class="footer-bar text-center">
                <div class="container">
                    <div class="row">
                        <div class="footer-bar-content w-100">
                            <p class="text-size-16 mb-0">
                                Copyright © 2024 All Rights Reserved
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Footer;
